import React, { useEffect, useState } from "react";

function Categorias() {
  const [categorias, setCategorias] = useState([]);
  const [form, setForm] = useState({});

  // ==============================
  // LISTAR CATEGORIAS
  // ==============================
  useEffect(() => {
    fetch("https://videooferta.com/api/listar_categorias.php", {
      method: "POST"
    })
      .then(res => res.json())
      .then(data => setCategorias(data))
      .catch(err => console.error(err));
  }, []);

  // ==============================
  // ATUALIZA FORM
  // ==============================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  }

  // ==============================
  // SALVAR CATEGORIA
  // ==============================
  function salvar(e) {
    e.preventDefault();

    fetch("https://videooferta.com/api/cadastrar_categoria.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        titulo: form.titulo || ""
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === "ok") {
          alert(data.msg);
          setForm({});
          setCategorias(prev => [...prev, data.categoria]);
        } else {
          alert("Erro: " + data.msg);
        }
      })
      .catch(err => {
        console.error(err);
        alert("Erro ao comunicar com o servidor");
      });
  }

  return (
    <div className="row">
      {/* LISTAGEM */}
      <div className="col-6">
        <h5>Categorias</h5>

        <table className="table table-bordered small align-middle">
          <thead>
            <tr>
              <th>ID</th>
              <th>Título</th>
            </tr>
          </thead>
          <tbody>
            {categorias.map(c => (
              <tr key={c.id}>
                <td>{c.id}</td>
                <td>{c.titulo}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* FORM */}
      <div className="col-6">
        <h5>Cadastrar Categoria</h5>

        <form onSubmit={salvar}>
          <div className="mb-2">
            <label>Título</label>
            <input
              className="form-control"
              name="titulo"
              value={form.titulo || ""}
              onChange={handleChange}
              required
            />
          </div>

          <button className="btn btn-primary w-100">
            Salvar Categoria
          </button>
        </form>
      </div>
    </div>
  );
}

export default Categorias;
